
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/faq",
      function () {
        return require("private-next-pages/[hid]/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hid]/faq"])
      });
    }
  